import { render, staticRenderFns } from "./FormatObjectSelectDialog.vue?vue&type=template&id=6c0e86d6&scoped=true&"
import script from "./FormatObjectSelectDialog.vue?vue&type=script&lang=ts&"
export * from "./FormatObjectSelectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FormatObjectSelectDialog.vue?vue&type=style&index=0&id=6c0e86d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0e86d6",
  null
  
)

export default component.exports